module.exports = "https://cdn.realtymogul.com/static/media/HIW_steps_1.ba19efd2.jpg";